import { useEffect, useCallback } from 'react';

/**
 * Хук для сохранения и восстановления позиции прокрутки.
 * @param scrollRef - Реф на скроллируемый элемент.
 * @param key - Уникальный ключ для хранения позиции прокрутки.
 * @returns Обработчик события прокрутки.
 */
function useScrollRestoration(
  scrollRef: React.RefObject<HTMLElement>,
  key: string
): (event: React.UIEvent<HTMLElement>) => void {
  // Восстановление позиции прокрутки при монтировании

  useEffect(() => {
    const targetElem = scrollRef.current?.querySelector('.treeInstanse');
    if (targetElem) {
      const savedScrollTop = sessionStorage.getItem(key);
      if (savedScrollTop !== null) {
        targetElem.scrollTop = parseInt(savedScrollTop, 10);
      }
    } else {
      console.warn('Скроллируемый элемент не найден. Проверьте селектор.');
    }
    const savedScrollTop = sessionStorage.getItem(key);
    if (scrollRef.current && savedScrollTop !== null) {
      scrollRef.current.scrollTop = parseInt(savedScrollTop, 10);
    }
  }, [scrollRef, key]);

  // Функция для сохранения позиции прокрутки
  const saveScrollPosition = useCallback(() => {
    if (scrollRef.current) {
      const targetElem = scrollRef.current?.querySelector('.treeInstanse');
      targetElem &&
        sessionStorage.setItem(key, targetElem.scrollTop.toString());
    }
  }, [scrollRef, key]);

  // Сохранение позиции при размонтировании или обновлении страницы
  useEffect(() => {
    const handleBeforeUnload = () => {
      saveScrollPosition();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      saveScrollPosition(); // Сохранить при размонтировании
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [saveScrollPosition]);

  // Обработчик события прокрутки для динамического сохранения позиции
  const handleScroll = useCallback(
    (event: React.UIEvent<HTMLElement>) => {
      const target = event.currentTarget.querySelector('.treeInstanse');
      sessionStorage.setItem(key, target!.scrollTop.toString());
    },
    [key]
  );

  return handleScroll;
}

export default useScrollRestoration;
